<template>
  <div class="cityListWrap">
      <!-- <nav-bar></nav-bar> -->
      <div class="cityList fc">
          <h3 class="title">定位城市</h3>
          <span @click="selectCity(currentCity, currentCityCode)" class="row fr ac">{{currentCity}}</span>
          <h3 class="title">当前选择城市</h3>
          <span class="row fr ac">{{selectedCity}}</span>
          <h3 class="title">热门城市</h3>
          <span v-for="(item) in hotCityList" :key="item.citycode" @click="selectCity(item.name, item.citycode)" class="row fr ac grey_border">{{item.name}}</span>
          <div v-for="item in cityInfo" :key="item.id" class="section fc">
              <h3 class="title">{{item.capital}}</h3>
              <span  @click="selectCity(cityItem.name, cityItem
              .citycode)" v-for="cityItem in item.city" :key="cityItem.citycode" class="row fr ac grey_border">{{cityItem.name}}</span>
          </div>
      </div>
  </div>
</template>

<script>
import navBar from "../../components/common/navBar.vue";
export default {
    data() {
        return {
            citylist: [],
            cityInfo: [],
            hotCityList: [],
            currentCity: this.getLocal('currentCity') ? this.getLocal('currentCity') : '上海',  //当前定位所在城市
            currentCityCode: this.getLocal('currentCityCode') ? this.getLocal('currentCityCode') : '310100',  //当前定位所在城市 CityCode
            selectedCity: this.getLocal('selectedCity') ? this.getLocal('selectedCity') : this.getLocal('currentCity') ? this.getLocal('currentCity') : '上海'
        };
    },
    components: {
        navBar
    },
    created(){
        this.getCityList();
    },
    methods: {
        //获取城市列表
        getCityList(){
            this.$post({
                method: 'movie.city.list'
            }).then(res => {
                if(res.success){
                    this.citylist = res.data.citylist
                    this.hotCityList = this.citylist.filter(item => item.ishot === true).map(self => { return {name: self.name, citycode: self.citycode} })
                    const tempArr = this.citylist.map(item => item.pinyin.substr(0, 1))
                    const searchLetter = Array.from(new Set(tempArr))
                    this.cityInfo = searchLetter.map(item => ({ capital: item, city: this.citylist.filter(self => self.pinyin[0] === item).map(self => { return { name: self.name, citycode: self.citycode } }), id: item }))
                    console.log(this.hotCityList, this.cityInfo)
                }
            })
        },
        selectCity(city, citycode){
            this.selectedCity = city;
            this.setLocal('selectedCity', city)
            this.setLocal('selectedCityCode', citycode)
            this.removeLocal("countycode");
            this.removeLocal("selectedCounty");
            this.$router.back(-1)
        }
    },

}

</script>
<style scoped lang="scss">
.cityListWrap {
    .cityList {
        background-color: #fff;
        .title {
            font-size: 30px;
            height: 80px;
            line-height: 50px;
            padding: 30px 20px 0 20px;
            color:#818181;
        }
        .row {
            height: 80px;
            margin: 0 30px;
            padding: 0 15px;
            font-size: 28px;
        }
        .row:last-of-type {
            border-bottom:  none;
        }
        .grey_border {
            border-bottom: 1px solid #c8c7cc; /*no*/
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/city/cityList.vue